import React, {useContext, useMemo, useState} from 'react'
import client from "../images/photo2.jpg";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {
    deleteClient,
    deleteOrder,
    getDocumentFromServer,
    orderProlong,
    rentVehicle,
    showAlert,
    updateOrder
} from "../redux/actions";
import {Carcontext} from "../context/carcontext";

const trash = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"></path></svg>
const block = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="ban" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zM103.265 408.735c-80.622-80.622-84.149-208.957-10.9-293.743l304.644 304.643c-84.804 73.264-213.138 69.706-293.744-10.9zm316.37-11.727L114.992 92.365c84.804-73.263 213.137-69.705 293.743 10.9 80.622 80.621 84.149 208.957 10.9 293.743z"></path></svg>
const calendar = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="calendar-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM148 320h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 96h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm192 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12z"></path></svg>

export const Ordermodal = (prop) => {

    const [tab, setTab] = useState('client')
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const [prolongedDate, setProlongedDate] = useState('')
    const [prolongedTime, setProlongedTime] = useState('')
    const extendedOrderData = useSelector(state => state.orders.extendedOrder)

    const { CloseModal } = useContext(Carcontext)

    function toggleTabs(e) {
        // try-catch block to prevent crash if order is not extended
        const firstTab = document.querySelector('.tabs > .client')
        const secondTab = document.querySelector('.tabs > .car')
        try {
            const thirdTab = document.querySelector('.tabs > .extended')
            if (e.target.id === 'client') {
                setTab('client')
                firstTab.classList.add('active')
                secondTab.classList.remove('active')
                thirdTab.classList.remove('active')
            }
            if (e.target.id === 'car') {
                setTab('car')
                secondTab.classList.add('active')
                firstTab.classList.remove('active')
                thirdTab.classList.remove('active')
            }
            if (e.target.id === 'extended') {
                setTab('extended')
                thirdTab.classList.add('active')
                secondTab.classList.remove('active')
                firstTab.classList.remove('active')
            }
        } catch (e) {}
        closeProplongOrder()
    }

    function stopOrder(e, id) {
        e.preventDefault()
        const edited = {status: "finished"}
        dispatch(updateOrder(id, edited))
        CloseModal()
    }

    function showProlongOrder(e) {
        e.stopPropagation()
        e.preventDefault()
        const panel = document.querySelector('.prolongDate')
        panel.classList.toggle('visible')
    }

    function closeProplongOrder() {
        const panel = document.querySelector('.prolongDate')
        if (panel.classList.contains('visible')) {
            panel.classList.remove('visible')
            setProlongedDate('')
            setProlongedTime('')
        }
    }

    function prolongOrder(e, order) {
        e.preventDefault()
        const edited = {
            to_date: prolongedDate,
            to_time: `${prolongedTime}:00`,
            order_id: order.order_id
        }
        dispatch(orderProlong(order.order_id, edited))
        closeProplongOrder()
        CloseModal()
    }

    function deleteOrderFunction(e, id) {
        e.preventDefault()
        const conf = window.confirm(`Do you wish to delete this order?`)
        if (conf) {
            dispatch(deleteOrder(id))
        }
        CloseModal()
    }

    function documentDownload(event, orderId, extended) {
        // prevent opening modalBox
        event.stopPropagation()
        dispatch(getDocumentFromServer(orderId, extended))
        dispatch(showAlert('You download will start soon', 'info'))
    }

    if (!prop.order) {
        return (
            <div className="modal">

            </div>
        )
    }

    return (
        <div className="functional-layer" onClick={closeProplongOrder}>
            <div className={`modal`}>
                <div className={`modal-content order modalbox ${prop.theme}`}>
                    <div className="prolongDate" onClick={e => e.stopPropagation()}>
                        <label htmlFor="prolong">Select a new ending date</label>
                        <input type="date" min={
                            prop.order.is_extended ?
                                (() => {
                                    try {
                                        return (
                                            `${new Date(extendedOrderData[extendedOrderData.length-1].to_date).getFullYear()}-${
                                                ((month) => {
                                                    if (Number(new Date(month).getMonth() + 1) < 10) {
                                                        return `0${new Date(month).getMonth() + 1}`
                                                    } else {
                                                        return `${new Date(month).getMonth() + 1}`
                                                    }
                                                }) (extendedOrderData[extendedOrderData.length-1].to_date)
                                            }-${
                                                ((date) => {
                                                    if (Number(new Date(date).getDate() + 1) < 10) {
                                                        return `0${new Date(date).getDate() + 1}`
                                                    } else {
                                                        return `${new Date(date).getDate() + 1}`
                                                    }
                                                }) (extendedOrderData[extendedOrderData.length-1].to_date)
                                            }`
                                        )
                                    } catch (e) {}
                                }) () :
                                `${new Date(prop.order.end).getFullYear()}-${
                                    ((month) => {
                                        if (new Date(month).getMonth() + 1 < 10) {
                                            return `0${new Date(month).getMonth() + 1}`
                                        } else {
                                            return `${new Date(month).getMonth() + 1}`
                                        }
                                    }) (prop.order.end)
                                }-${
                                    ((date) => {
                                        if (new Date(date).getDate() < 10) {
                                            return `0${new Date(date).getDate() + 1}`
                                        } else {
                                            return `${new Date(date).getDate() + 1}`
                                        }
                                    }) (prop.order.end)
                                }`
                        } id="prolong" onChange={event => setProlongedDate(event.target.value)}/>
                        <label htmlFor="prolongTime">Select a new ending date</label>
                        <input type="time" id="prolongTime" onChange={event => setProlongedTime(event.target.value)}/>
                        <button onClick={showProlongOrder} className="cancel">Cancel</button>
                        <button onClick={e => prolongOrder(e, prop.order)}>Confirm</button>
                    </div>
                    <div className="tabs">
                        <div className="tab active client" id="client" onClick={toggleTabs}>{t('client')}</div>
                        <div className="tab car" id="car" onClick={toggleTabs}>{t('car')}</div>
                        {prop.order.is_extended &&
                            <div className="tab extended" id="extended" onClick={toggleTabs}>Extended</div>
                        }
                    </div>
                    {
                        (() => {
                            if (tab === 'client') {
                                return (
                                    <div className="client-top order">
                                        <div className="client-left">
                                            <div className="client-imagebox">
                                                <img className="client-image" src={
                                                    !!prop.order.client_photo ? `https://rezilizer.ru/media/${prop.order.client_photo}` :
                                                        client
                                                } alt="client: client" />
                                            </div>
                                            <div className="client-info">
                                                <h2 className="client-info-surname">{t('name')}: <strong>{prop.order.lastname}</strong></h2>
                                                <h2 className="client-info-name">{t('surname')}: <strong>{prop.order.firstname}</strong></h2>
                                                <p className="client-number">{t('passport')}: <strong>{prop.order.passport}</strong></p>
                                                <p className="client-number">{t('telephone')}: <strong>+998 {prop.order.client_phone}</strong></p>
                                            </div>
                                        </div>
                                        {(() => {
                                            if (prop.order.status === 'in progress') {
                                                return (
                                                    <div className="for-rent">
                                                        <div className="buttons">
                                                            <div className="rent-btn danger" onClick={e => stopOrder(e, prop.order.order_id)}><p>{t('stop')}</p>{block}</div>
                                                            <div className="rent-btn save" onClick={e => showProlongOrder(e)}><p>{t('prolong')}</p>{calendar}</div>
                                                            <div className="rent-btn delete" onClick={e => deleteOrderFunction(e, prop.order.order_id)}><p>{t('delete')}</p>{trash}</div>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div className="for-rent">
                                                        <div className="buttons">
                                                            <div className="rent-btn delete" onClick={e => deleteOrderFunction(e, prop.order.order_id)}><p>{t('delete')}</p>{trash}</div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        }) ()}
                                    </div>
                                )
                            } else if (tab === 'car') {
                                return (
                                    <>
                                        <div className="modalbox-top">
                                            <div className="modalbox-info">
                                                <h2 className="modalbox-title">{prop.order.brand} {prop.order.model}</h2>
                                                <p className="modalbox-number">{prop.order.car_num}</p>
                                            </div>
                                            <div className="modalbox-condition">
                                                <div className="modalbox-isactive">
                                                </div>
                                                <div className="modalbox-imagebox">
                                                    <img className="modalbox-image" src={`https://rezilizer.ru/media/${prop.order.car_photo}`} alt="car: car" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modalbox-content">
                                            <div className="modalbox-content-item">
                                                <h4 className="modalbox-subtitle">{t('startDate')}</h4>
                                                <p className="modalbox-descr">
                                                    {new Date(prop.order.start).toDateString()}
                                                </p>
                                            </div>
                                            <div className="modalbox-content-item">
                                                <h4 className="modalbox-subtitle">{t('endDate')}</h4>
                                                <p className="modalbox-descr">
                                                    {new Date(prop.order.end).toDateString()}
                                                </p>
                                            </div>
                                            {(() => {
                                                if (prop.order.status === 'in progress') {
                                                    return (
                                                        <div className="for-rent">
                                                            <div className="buttons">
                                                                <div className="rent-btn danger" onClick={e => stopOrder(e, prop.order.order_id)}><p>{t('stop')}</p>{block}</div>
                                                                <div className="rent-btn save" onClick={e => showProlongOrder(e)}><p>{t('prolong')}</p>{calendar}</div>
                                                                <div className="rent-btn delete" onClick={e => deleteOrderFunction(e, prop.order.order_id)}><p>{t('delete')}</p>{trash}</div>
                                                            </div>
                                                        </div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="for-rent">
                                                            <div className="buttons">
                                                                <div className="rent-btn delete" onClick={e => deleteOrderFunction(e, prop.order.order_id)}><p>{t('delete')}</p>{trash}</div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            }) ()}
                                        </div>
                                    </>
                                )
                            } else if (tab === 'extended') {
                                if (prop.order.is_extended) {
                                    return (
                                        <div className="extended-tab">
                                            {
                                                extendedOrderData.map((item, key) => {
                                                    return (
                                                        <div key={key}>
                                                            <div className="extended-rents-wrapper">
                                                                <div className="extended-rent">
                                                                    <h3>{key + 1}</h3>
                                                                    <div className="extended-rent-data">
                                                                        <div className="dates">
                                                                            <h4>{t('fromTo')}</h4>
                                                                            <h5>{new Date(item.from_date).toDateString()} -- {new Date(item.to_date).toDateString()}</h5>
                                                                        </div>
                                                                        <div className="time">
                                                                            <h4>{t('fromTo')}</h4>
                                                                            <h5>{item.from_time} -- {item.to_time}</h5>
                                                                        </div>
                                                                    </div>
                                                                    <button onClick={event => documentDownload(event, item.id, true)} className="order-button">{t('download')}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                } else {
                                    setTab('client')
                                    document.querySelector('.tabs > .client').classList.add('active')
                                }
                            }
                        }) ()
                    }
                </div>
            </div>
        </div>
    )
}
